import { useEffect, useRef } from 'react';
import { ApolloQueryResult } from '@apollo/client';
// Hooks
import { useGetCurrUser } from 'hooks';

type UseRefetchOnUserLogInProps = {
  refetch: (
    variables?: Partial<any> | undefined
  ) => Promise<ApolloQueryResult<any>>;
};

export const useRefetchOnUserLogIn = ({
  refetch,
}: UseRefetchOnUserLogInProps): null => {
  const { data: userData } = useGetCurrUser();
  const userId = userData?.me.id;
  const isInitialLoad = useRef(true);

  useEffect(() => {
    // Skip refetch on initial load, only refetch when user actually logs in
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    if (userId) {
      refetch();
    }
  }, [userId, refetch]);

  return null;
};
